import getApi from '../../api'
import {
  deserializeGaussIframeUrlResponse,
  GaussIframeUrlResource,
} from './mapper/gaussIframeUrl.mapper'

export const getGaussIframeUrl = () =>
  getApi()
    .get<GaussIframeUrlResource>('/external-services/gauss/iframe-url')
    .then(deserializeGaussIframeUrlResponse)
